/* eslint-disable react/require-default-props */
import React, { useEffect, useContext, useRef } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { extend, QueryProvider, useDataModel } from '@thd-nucleus/data-sources';
import proptypes from 'prop-types';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { NoResultsFoundBanner } from '@thd-olt-component-react/no-results-found-banner';
import { ShopByCategory } from '@thd-olt-component-react/shop-by-category';
import { RetailMediaCarousel } from '@thd-olt-component-react/retail-media-pla-sponsored-placements';
import { PlpRecsRenderPlaceholder } from '@thd-olt-component-react/thd-recs-containers';
import { RECS_REQUEST_KEY as defaultRequestKey } from '../const';

const { string, bool, func, shape } = proptypes;

const NoResultsFound = ({
  keyword: keywordProp,
  searchData: searchDataProp = undefined,
  cpoOnly = false,
  onCpoClick = () => {},
  pageType: pageTypeProp = '',
  requestKey: requestKeyProp = ''
}) => {
  const ctx = useContext(ExperienceContext);
  const { channel, customContext } = ctx || {};
  const { pageType: contextPageType, variables = {} } = customContext || {};
  const { keyword: contextKeyword } = variables;
  const isMobile = channel === 'mobile';
  const keyword = keywordProp || contextKeyword || '';
  const pageType = pageTypeProp || contextPageType || '';
  const RECS_REQUEST_KEY = requestKeyProp || defaultRequestKey || '';

  useEffect(() => {
    if (typeof LIFE_CYCLE_EVENT_BUS !== 'undefined') {
      LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('no-results-found.ready');
    }
  }, []);
  useEffect(() => {
    if (typeof LIFE_CYCLE_EVENT_BUS !== 'undefined') {
      LIFE_CYCLE_EVENT_BUS.trigger('no-results.loaded', { keyword });
    }
  }, []);
  const isControlledData = typeof searchDataProp !== 'undefined';
  const defaultOptions = {
    variables: {
      ...variables,
    },
    ssr: true,
    skip: isControlledData || (!variables?.keyword && !variables?.navParam)
  };
  const { data: fetchedSearchData = {} } = useDataModel('searchModel', defaultOptions);
  const searchData = searchDataProp || fetchedSearchData;

  const crumbs = [
    { label: 'Text Search', url: '' },
    { label: keyword, url: `/s/${keyword}?NCNI-5` }
  ];

  return (
    <div data-component="NoResultsFound" data-testid="no-results-found">
      <QueryProvider cacheKey="no-results-found">
        <div className="sui-grid sui-grid-cols-12">
          <div className="sui-col-span-12 md:sui-col-start-2 md:sui-col-span-10 ">
            <Breadcrumbs staticCrumbs={crumbs} hideOnNoCategory={isMobile} />
            <NoResultsFoundBanner keyword={keyword} cpoOnly={cpoOnly} onCpoClick={onCpoClick} />
            <PlpRecsRenderPlaceholder
              requestKey={RECS_REQUEST_KEY}
              keyword={keyword}
            />
            <div className="md:sui-pt-6">
              <ShopByCategory
                componentId="6dMXpZOWCDgD4ZzahLfBpJ"
                componentClass="ShopByCategory"
              />
            </div>
            <div className="sui-pt-4 md:sui-pt-10" data-testid="sponsored-carousel-nrf">
              <RetailMediaCarousel
                plaLocation="sponsoredCarouselNoResultsFoundPage"
                pageContext={{
                  schema: 'no_results_found_sponsored',
                  keyword,
                  data: {
                    searchModel: searchData?.searchModel,
                  },
                }}
                showSponsoredCarousel
                dynamic={{
                  pageType
                }}
                hydrator={{
                  className: 'grid',
                  scrollBuffer: 750
                }}
              />
            </div>
          </div>
        </div>
      </QueryProvider>
    </div>
  );
};

NoResultsFound.displayName = 'NoResultsFound';

NoResultsFound.propTypes = {
  keyword: string.isRequired,
  searchData: shape({}),
  cpoOnly: bool,
  onCpoClick: func,
  pageType: string,
  requestKey: string,
};

NoResultsFound.dataModel = extend({}, PlpRecsRenderPlaceholder, Breadcrumbs);

export { NoResultsFound };
